import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	GetExamsList,
	GetExamsListModel,
	GetExamsListParams,
} from 'domain/usecases/private/my-hospitalization/get-exams-list';

export class RemoteGetExamsList implements GetExamsList {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetExamsListModel>,
	) {}

	async get({signal, ...params}: GetExamsListParams): Promise<GetExamsListModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
